import { render, staticRenderFns } from "./CRMDetailHead.vue?vue&type=template&id=e9dafb84&scoped=true"
import script from "./CRMDetailHead.vue?vue&type=script&lang=js"
export * from "./CRMDetailHead.vue?vue&type=script&lang=js"
import style0 from "./CRMDetailHead.vue?vue&type=style&index=0&id=e9dafb84&prod&lang=scss"
import style1 from "./CRMDetailHead.vue?vue&type=style&index=1&id=e9dafb84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9dafb84",
  null
  
)

export default component.exports